import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import ToggleNavigation from "components/Toggle/ToggleNavigation";
import Toggle from "components/Toggle/Toggle";

import {NotificationContext} from "../../../../../NotificationContext";
import {SidebarContext} from "../../../../../../../../../../../SidebarContext";

function NotificationToggleNavigation(props) {
    const {isMobile} = useContext(SidebarContext);

    const {
        setSelectedNavigationToggle,
        selectedNavigationToggle,
        notificationsCount,
        notificationsViewedCount,
        notificationsNotViewedCount
    } = useContext(NotificationContext);

    return (
        <div style={{
            padding: isMobile ? '20px 0px 0px 0px' : '20px 12px 0px 12px',
            marginBottom: '20px'
        }}>
            <ToggleNavigation
                fullWidth={true}
                value={selectedNavigationToggle}
                onChange={(value) => setSelectedNavigationToggle(value) }
                autoMargin
            >
                <Toggle
                    fullWidth={true}
                    label={<FormattedMessage id='sidebar.profil.notification.menu.all' />}
                    count={notificationsCount}
                    autoHeight
                />

                <Toggle
                    fullWidth={true}
                    label={<FormattedMessage id='sidebar.profil.notification.menu.read' />}
                    count={notificationsViewedCount}
                    autoHeight
                />
                <Toggle
                    fullWidth={true}
                    label={<FormattedMessage id='sidebar.profil.notification.menu.notRead' />}
                    count={notificationsNotViewedCount}
                    noWrapText
                    autoHeight
                />
            </ToggleNavigation>
        </div>
    );
}

export default NotificationToggleNavigation;
